import { Component, OnDestroy, signal } from '@angular/core'
import { Subject, takeUntil } from 'rxjs'
import { RolloutsMapMetrics, getMetricFromMap } from '../../../shared/metrics/rollouts-map-metrics'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { MetricModel } from 'src/app/shared/models/metric.model'
import { Layers } from 'src/app/shared/layers-config/layers'

@Component({
  selector: 'app-customer-legend',
  templateUrl: './customer-legend.component.html',
  standalone: false,
})
export class CustomerLegendComponent implements OnDestroy {
  private cleanUp$ = new Subject<void>()
  public metrics: string | undefined
  public isRolloutMetricLayerVisible = signal(false)
  public isLayerSelectionVisible = false

  public rolloutMetric = signal<MetricModel | undefined>(undefined)

  constructor(private appState: AppStateService) {
    this.evaluateQueryParameters()

    this.appState.stateChanged.pipe(takeUntil(this.cleanUp$)).subscribe(() => {
      this.evaluateQueryParameters()
    })
  }
  ngOnDestroy(): void {
    this.cleanUp$.next()
    this.cleanUp$.complete()
  }

  evaluateQueryParameters() {
    this.isRolloutMetricLayerVisible.set(
      this.appState.getState().layers?.includes(Layers.RolloutsTile.name) ?? false,
    )

    const rolloutsMetricKeys = this.appState.selectMetrics(Layers.RolloutsTile.name)
    if (rolloutsMetricKeys && rolloutsMetricKeys.length > 0) {
      this.rolloutMetric.set(getMetricFromMap(rolloutsMetricKeys[0]))
    }
  }
}
